import { useState, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { Dropdown } from '@linktivity/link-ui';
import { User } from '@linktivity/link-icons';
import { useStore } from '@/stores';
import styles from './header.module.css';

const UserView = () => {
  const { auth } = useStore();
  const { t } = useTranslation();
  const [openMenu, setOpenMenu] = useState(false);

  const userButton = useMemo(
    () => (
      <button
        className={styles.button}
        type="button"
        onClick={() => setOpenMenu(visible => !visible)}
      >
        <User className={styles.icon} />
        <span className={styles.text}>{t('common.account')}</span>
      </button>
    ),
    [t]
  );

  const logout = useCallback(() => {
    auth.logout();
  }, [auth]);

  return (
    <Dropdown
      target={userButton}
      visible={openMenu}
      sameWidth={false}
      placement="bottom-end"
      onClose={() => setOpenMenu(false)}
    >
      <Dropdown.Menu className={styles.dropdownMenu}>
        <Dropdown.Item>
          <button className={styles.dropdownButton} onClick={logout}>
            {t('common.signOut')}
          </button>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
const ObserverUserView = observer(UserView);
export default ObserverUserView;
